let sensors = require('sa-sdk-javascript');

// 数据接收测试地址
let serverUrl = '',
  showLog = true;
switch (location.hostname) {
  case 'passports.laihua.com':
  case '127.0.0.1':
  case 'localhost':
  case 'beta.laihua.com':
    serverUrl = 'https://api-sensorsdata.laihua.com/sa?project=default';
    showLog = true;
    break;
  case 'www.laihua.com':
  case 'laihua.com':
    serverUrl = 'https://api-sensorsdata.laihua.com/sa?project=production';
    showLog = false;
    break;
  default:
    serverUrl = '';
    break;
}

sensors.init({
  name: 'sensors',
  server_url: serverUrl,
  show_log: showLog,
  heatmap: {
    //是否开启点击图，默认为 default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
    clickmap: 'default',
    //是否开启触达注意力图，默认 not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
    scroll_notice_map: 'default'
  }
});

sensors.__track = sensors.track;
sensors.track = function myTrack (eventName, eventData, ...args) {
  return sensors.__track(eventName, {
    version: '5.6.3',
    ...eventData
  }, ...args);
};

// 自动收集页面浏览事件( $pageview 事件)，以及设置初始来源。
// sensors.quick('autoTrack');

// 注册公共属性
// sensors.registerPage({
//   platform_type: 'web'
// });

sensors.use('PageLeave', { heartbeat_interval_time: 1 });

export default sensors;



// WEBPACK FOOTER //
// ./src/sensorsIndex.js